import {
  Plus, X, Check, ChevronUp, ChevronDown, Printer, Pencil, Send, Search, Palette,
  Trash2, User, Calendar, Zap, AlertTriangle, Pin, ChevronRight, GripVertical,
  CheckCircle2, Info, Scissors, ClipboardPaste, Copy, ChevronLeft, PanelLeft, PanelRight,
  MoreHorizontal, NotepadText, ListSortDescending, Bell, Flag, Clock, BadgeAlert, Tv,
  Download, ExternalLink, CalendarRange, CircleHelp, SlidersHorizontal, Menu,
} from 'lucide-react'

/**
 * A name-keyed registry over lucide-react rather than a raw import per call site: every
 * caller already asks for an icon by a short string ("close", "trash", "up") through this
 * one component, and `ContextMenuItem`'s `icon` prop passes a string through unchanged —
 * swapping what's behind the name out for lucide, instead of touching every one of those
 * call sites, is what keeps this a one-file change.
 *
 * A mode's glyph is NOT here: it belongs with the mode's colours in lib/tileLook.js, since
 * a name-keyed registry could only ever hand back a shape, and every place that draws a
 * mode needs the pair.
 */
const ICONS = {
  plus: Plus,
  close: X,
  check: Check,
  up: ChevronUp,
  down: ChevronDown,
  printer: Printer,
  edit: Pencil,
  send: Send,
  search: Search,
  palette: Palette,
  trash: Trash2,
  person: User,
  calendar: Calendar,
  // Copying a day across several: the range, not the single day time off uses.
  calendarRange: CalendarRange,
  clock: Clock,
  badgeAlert: BadgeAlert,
  bolt: Zap,
  alert: AlertTriangle,
  pin: Pin,
  right: ChevronRight,
  grip: GripVertical,
  checkCircle: CheckCircle2,
  info: Info,
  cut: Scissors,
  paste: ClipboardPaste,
  copy: Copy,
  back: ChevronLeft,
  panelLeft: PanelLeft,
  panelRight: PanelRight,
  more: MoreHorizontal,
  note: NotepadText,
  sort: ListSortDescending,
  // How the board is laid out for the person looking at it — not a setting of the company's.
  sliders: SlidersHorizontal,
  // A reorder handle: the three lines a list shows beside what can be dragged into place.
  reorder: Menu,
  bell: Bell,
  // The wall view — the screen in the workshop, not the settings page that pairs them.
  tv: Tv,
  download: Download,
  // A link that opens in a new tab, said before it is clicked rather than discovered after.
  external: ExternalLink,
  // A statutory holiday. Deliberately not a party popper or similar: several of
  // these days are solemn ones — Remembrance Day, Truth and Reconciliation — and a
  // celebratory glyph would be wrong on them.
  holiday: Flag,
  // Help, in the top bar. The one way into it, so it wears the convention people already
  // look for rather than a word that would read as a sixth destination in the nav.
  help: CircleHelp,
}

export default function Icon({ name, size = 18, className = '', strokeWidth = 1.7 }) {
  const Cmp = ICONS[name]
  if (!Cmp) return null
  return (
    <Cmp
      className={`icon ${className}`}
      size={size}
      strokeWidth={strokeWidth}
      aria-hidden="true"
      focusable="false"
    />
  )
}
